<template>
  <q-inner-loading v-if="reportLoading || organizationLoading" showing color="secondary" />
  <property-compare
    v-else
    :comparable-addresses="synetheticReport.comparable_addresses"
    :subject="synetheticReport.subject"
    :report="synetheticReport"
  />
</template>

<script lang="ts">
import PropertyCompare from '@/components/PropertyReports/PropertyCompare.vue'
import type { PropertyEdits, RentSourceSubscriptionAttributes } from 'common'
import { usePropertyReportStore } from '@/stores/propertyreport'
import { useRoute } from 'vue-router'
import { useUserStore } from '@/stores/user'

export default {
  name: 'PropertyReportByTagView',
  components: {
    PropertyCompare
  },
  data() {
    return {
      reportLoading: false,
      reports: [] as RentSourceSubscriptionAttributes[]
    }
  },
  computed: {
    synetheticReport() {
      const subjectIds = [
        ...new Set(this.reports.flatMap((_) => (_.subject ? [_.subject.id] : [])))
      ]
      const comparableAddresses = subjectIds.map(
        (subjectId) => this.reports.find((_) => _.subject?.id === subjectId)!.subject
      )
      const propertyEdits: PropertyEdits[] = []
      for (const report of this.reports) {
        if (report.property_edits?.length) {
          propertyEdits.push(...report.property_edits)
        }
      }
      return {
        id: -1,
        name: `${this.tag} Report`,
        subject: null,
        comparable_addresses: comparableAddresses,
        excluded_property_ids: [],
        emails: [],
        schedule: [],
        user_id: '',
        modified_on: this.reports.length
          ? this.reports
              .map((_) => _.modified_on)
              .reduce((a, b) => (a > b ? a : b), this.reports[0].modified_on)
          : new Date(),
        created_on: this.reports.length
          ? this.reports
              .map((_) => _.created_on)
              .reduce((a, b) => (a > b ? a : b), this.reports[0].created_on)
          : new Date(),
        deleted_on: null,
        last_run_on: null,
        public_id: null,
        is_organization_visible: false,
        tags: [this.tag],
        feature_flags: [],
        property_edits: propertyEdits,
        view_preferences: []
      } as RentSourceSubscriptionAttributes
    },
    tag() {
      const route = useRoute()
      return route.query['tag'] as string
    },
    organizationLoading() {
      return useUserStore().organizationLoading
    }
  },
  watch: {
    tag() {
      this.loadReports()
    }
  },
  created() {
    this.loadReports()
  },
  methods: {
    loadReports() {
      if (this.tag) {
        this.reportLoading = true
        usePropertyReportStore()
          .getByTag(this.tag)
          .then((response) => {
            if (!response.length) {
              this.$router.push({ name: 'Dashboard' })
            } else {
              this.reports = response
            }
          })
          .finally(() => {
            this.reportLoading = false
          })
      }
    }
  }
}
</script>
